import NextAuth from "next-auth"
import { cache } from "react"

import { authConfig } from "./config"

const { auth: uncachedAuth, handlers, signIn, signOut } = NextAuth(authConfig)

const auth = cache(uncachedAuth)

const BASEURL_GQL = "https://cms-website.edify.club/graphql"
// const BASEURL_GQL = "https://1d4f-34-47-179-100.ngrok-free.app/graphql"
const BASEURL_API = "https://gcp-api.edify.club"
// staging
// const BASEURL_API = "http://34.93.74.197:8880/"

export { auth, handlers, signIn, signOut, BASEURL_GQL, BASEURL_API }
